"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgWind = function SvgWind(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M1 7a1 1 0 010-2h5.071C6.576 5 7 4.56 7 4s-.424-1-.929-1a.89.89 0 00-.647.283 1 1 0 01-1.446-1.38A2.888 2.888 0 016.07 1C7.697 1 9 2.351 9 4S7.697 7 6.071 7H1z",
    fill: "currentColor"
  }), _react.default.createElement("path", {
    d: "M1 10a1 1 0 010-2h11.658C13.384 8 14 7.343 14 6.5S13.384 5 12.658 5c-.35 0-.68.15-.93.421a1 1 0 01-1.467-1.36A3.262 3.262 0 0112.658 3C14.518 3 16 4.581 16 6.5S14.519 10 12.658 10H9.672c.21.455.328.964.328 1.5 0 1.925-1.519 3.5-3.41 3.5-.93 0-1.802-.385-2.437-1.05a1 1 0 111.446-1.382c.264.277.616.432.99.432C7.36 13 8 12.336 8 11.5S7.36 10 6.59 10H1z",
    fill: "currentColor"
  }));
};

SvgWind.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgWind;
exports.default = _default;